import getClusterId from '@/common/store/pinia/storageCluster/getClusterId';
import { AbgwReverseProxyingUpstreamsSettingsSetData, AbgwUpstream } from '@schema';
import useCommonStore from '@/common/store/pinia/common';
import api from '@/common/utils/api';
import { defineStore } from 'pinia';
import abgwNotificationHandler from '@/common/utils/abgwNotificationHandler';
import takeFirst from '@/common/utils/takeFirst';
import abgwUpstreamsMapper, { AbgwUpstreamMapped } from '@/common/store/pinia/abgwUpstreams/abgwUpstreamsMapper';

const getUrl = async () => {
  const clusterId = await getClusterId();
  return `/api/v2/${clusterId}/abgw/reverse-proxying/upstreams`;
};

export type AbgwUpstreamSettings = NonNullable<AbgwReverseProxyingUpstreamsSettingsSetData['body']>;

export const useAbgwUpstreamsStore = defineStore('abgwUpstreams', () => {
  const commonStore = useCommonStore<AbgwUpstream, AbgwUpstreamMapped>({
    getUrl,
    itemKey: 'dc_uid',
    plural: data => data,
    mapItem: abgwUpstreamsMapper,
  })();

  const setSettings = async (upstreamUid: string, settings: AbgwUpstreamSettings) => {
    const url = await getUrl();
    const item = await api.patch<AbgwUpstream>(`${url}/${upstreamUid}/settings/`, settings);
    commonStore.changeItem(item.data);
  };

  const onAbgw = abgwNotificationHandler('upstream', {
    changed: () => takeFirst(commonStore.fetchItems)
  });

  return {
    ...commonStore,
    setSettings,
    onAbgw
  };
}, {
  ws: {
    abgw: 'onAbgw'
  }
});

export default useAbgwUpstreamsStore;
